import { useAuthStore } from '../stores/auth';
import { useQuery } from '@tanstack/react-query';
import { getCanvaStatus } from '../api/canva';

export function Settings() {
  const user = useAuthStore((s) => s.user);

  const { data: canvaStatus } = useQuery({
    queryKey: ['canvaStatus'],
    queryFn: getCanvaStatus,
  });

  return (
    <div className="space-y-6 animate-fadeIn max-w-2xl">
      <h1 className="text-xl font-bold text-gray-900">Settings</h1>

      {/* User Info */}
      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h2 className="text-sm font-semibold text-gray-700 mb-3">Benutzer</h2>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-500">Name</span>
            <span className="text-gray-900 font-medium">{user?.full_name ?? '–'}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">E-Mail</span>
            <span className="text-gray-900">{user?.email}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Rolle</span>
            <span className="text-gray-900">{user?.role}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Tenant</span>
            <span className="text-gray-900">{user?.tenant_name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Platform Admin</span>
            <span className="text-gray-900">{user?.is_platform_admin ? 'Ja' : 'Nein'}</span>
          </div>
        </div>
      </div>

      {/* Canva Status */}
      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h2 className="text-sm font-semibold text-gray-700 mb-3">Canva Integration</h2>
        <div className="flex items-center gap-2">
          <span
            className={`h-2.5 w-2.5 rounded-full ${
              canvaStatus?.connected ? 'bg-green-500' : 'bg-red-400'
            }`}
          />
          <span className="text-sm text-gray-700">
            {canvaStatus?.connected ? 'Verbunden' : 'Nicht verbunden'}
          </span>
        </div>
      </div>

      {/* About */}
      <div className="bg-white border border-gray-200 rounded-xl p-5">
        <h2 className="text-sm font-semibold text-gray-700 mb-3">Über</h2>
        <p className="text-sm text-gray-500">
          IdeaPilot Validation Cockpit v0.1.0
          <br />
          Standalone-Validierungs-App für IdeaPilot.
        </p>
      </div>
    </div>
  );
}
